import { UserType } from 'src/models/userType';

export const isDeepLinkAccessible = (userType: UserType): boolean => {
    const isUserEmployerOrApplicant = userType === UserType.Employer || userType === UserType.Applicant;
    return isUserEmployerOrApplicant;
};
